import { ClassicForm } from "@/pages/classic-form";
import { makeAttach } from "./lib/makeAttach.browser";

export const attach = makeAttach(ClassicForm, "classic");
